import { Button, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import { RESET_BUTTON_TEST_ID, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const IntervalOemDefault: FunctionComponent<Props> = ({
    canReset,
    className = '',
    oemLabel,
    onReset,
    resetLabel,
    testId = TEST_ID
}) => (
    <VerticalContainer className={`${styles.intervalOemDefault} ${className}`} testId={testId}>
        <Wrapper className={styles.oemLabel}>{oemLabel}</Wrapper>

        {canReset && (
            <Button
                className={styles.resetButton}
                onClick={onReset}
                testId={RESET_BUTTON_TEST_ID}
                text={resetLabel}
            />
        )}
    </VerticalContainer>
);

export default IntervalOemDefault;
